export default "__VITE_ASSET__Do7NzI9X__"